import { AppState } from "store/AppState"

export const selectNewsletterPreviewHtmlPending = (s: AppState) =>
  s.newsletter.newsletterPreviewHtml.pending
export const selectNewsletterPreviewHtmlFetchError = (s: AppState) =>
  s.newsletter.newsletterPreviewHtml.error

export const selectNewsletterPreviewHtml = (s: AppState) =>
  s.newsletter.newsletterPreviewHtml.data || ""
